import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import teacher from './modules/teacher'
import mobile from './modules/mobile'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    teacher,
    mobile
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js